import {
  AiCreateArtworkModel,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo,
} from '~/graphqls/types'

export type ExtendsProduct = Omit<
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  '__typename'
> &
  Partial<
    Omit<pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo, '__typename'>
  >

export const modelOptions = [
  {
    model: AiCreateArtworkModel.STABLE_DIFFUSION,
    name: '通用模型',
    desc: '速度快，逻辑性强',
    img: '/images/ai/sd.png',
    isNew: false,
  },
  {
    model: AiCreateArtworkModel.ANIME_DIFFUSION,
    name: '二次元模型',
    desc: '快速生成二次元图像',
    img: '/images/ai/ad.png',
    isNew: true,
  },
  {
    model: AiCreateArtworkModel.DISCO_DIFFUSION,
    name: '色彩模型',
    desc: '速度慢，色彩恢弘',
    img: '/images/ai/dd.png',
    isNew: false,
  },
]
